/* En Çok Satanlar ana sayfa davranışları: hero slider, yatay şerit okları, sekmeler, galeri, önce/sonra.
   Birden çok section aynı dosyayı çağırır → tek kez kurulur. Tema düzenleyicisinde yeniden yüklenen
   section shopify:section:load ile tekrar başlatılır. */
(function () {
  if (window.__esAnasayfa) return;
  window.__esAnasayfa = true;

  var azHareket = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hepsi = function (kok, sec) { return Array.prototype.slice.call(kok.querySelectorAll(sec)); };
  var kendisiVeAlti = function (kok, sec) {
    var liste = hepsi(kok, sec);
    if (kok.matches && kok.matches(sec)) liste.unshift(kok);
    return liste;
  };

  function slider(el) {
    if (el.__es) return; el.__es = true;
    var slaytlar = hepsi(el, '[data-es-slayt]');
    var noktalar = hepsi(el, '[data-es-nokta]');
    if (slaytlar.length < 2) return;
    var i = 0, zaman = null;
    var sure = parseInt(el.getAttribute('data-sure'), 10) || 0;
    // Tek kaynaktan karar: herhangi bir neden varsa durur, hepsi kalkınca devam eder.
    var neden = { fare: false, odak: false, dokunma: false, editor: false, kullanici: false };
    var duraklat = el.querySelector('[data-es-duraklat]');
    function git(n) {
      i = (n + slaytlar.length) % slaytlar.length;
      slaytlar.forEach(function (s, k) { s.classList.toggle('is-on', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      noktalar.forEach(function (d, k) { d.classList.toggle('is-on', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function guncelle() {
      if (!el.isConnected) { clearInterval(zaman); zaman = null; return; }  // editörde yeniden yüklenen eski kopya
      var dursun = sure <= 0 || azHareket || document.hidden || Object.keys(neden).some(function (k) { return neden[k]; });
      if (dursun) { clearInterval(zaman); zaman = null; }
      else if (!zaman) zaman = setInterval(function () { el.isConnected ? git(i + 1) : guncelle(); }, sure * 1000);
    }
    function ayarla(k, v) { neden[k] = v; guncelle(); }
    el.__esDurdur = function (v) { ayarla('editor', v); };
    el.__esGit = git;
    var onceki = el.querySelector('[data-es-onceki]'), sonraki = el.querySelector('[data-es-sonraki]');
    if (onceki) onceki.addEventListener('click', function () { git(i - 1); });
    if (sonraki) sonraki.addEventListener('click', function () { git(i + 1); });
    noktalar.forEach(function (d) { d.addEventListener('click', function () { git(parseInt(d.getAttribute('data-es-nokta'), 10)); }); });
    if (duraklat) duraklat.addEventListener('click', function () {
      var durdu = !neden.kullanici;
      duraklat.setAttribute('aria-pressed', durdu ? 'true' : 'false');
      duraklat.setAttribute('aria-label', durdu ? 'Otomatik geçişi başlat' : 'Otomatik geçişi durdur');
      ayarla('kullanici', durdu);
    });
    el.addEventListener('mouseenter', function () { ayarla('fare', true); });
    el.addEventListener('mouseleave', function () { ayarla('fare', false); });
    el.addEventListener('focusin', function () { ayarla('odak', true); });
    el.addEventListener('focusout', function (e) { if (!el.contains(e.relatedTarget)) ayarla('odak', false); });
    document.addEventListener('visibilitychange', guncelle);
    var x0 = null, y0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; ayarla('dokunma', true); }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = y0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) git(dx < 0 ? i + 1 : i - 1);  // dikey kaydırma slaytı değiştirmez
      ayarla('dokunma', false);
    }, { passive: true });
    el.addEventListener('touchcancel', function () { x0 = y0 = null; ayarla('dokunma', false); }, { passive: true });
    git(0); guncelle();
  }

  function serit(el) {
    if (el.__esSerit) return; el.__esSerit = true;
    var geri = el.querySelector('[data-es-geri]'), ileri = el.querySelector('[data-es-ileri]');
    function iz() {
      return hepsi(el, '[data-es-iz]').filter(function (t) { return t.offsetParent !== null; })[0];
    }
    function guncelle() {
      if (!el.isConnected) { window.removeEventListener('resize', guncelle); return; }
      var t = iz(); if (!t || !geri || !ileri) return;
      // disabled değil aria-disabled: odaklı düğme devre dışı kalınca klavye odağı body'ye düşmesin.
      geri.setAttribute('aria-disabled', t.scrollLeft <= 2 ? 'true' : 'false');
      ileri.setAttribute('aria-disabled', t.scrollLeft + t.clientWidth >= t.scrollWidth - 2 ? 'true' : 'false');
    }
    function kaydir(yon) {
      var t = iz(); if (!t) return;
      var oge = t.firstElementChild;
      var adim = oge ? oge.getBoundingClientRect().width + parseFloat(getComputedStyle(t).columnGap || 0) : t.clientWidth;
      var gorunen = Math.max(1, Math.floor((t.clientWidth + 1) / adim));
      t.scrollBy({ left: yon * adim * gorunen, behavior: azHareket ? 'auto' : 'smooth' });
    }
    if (geri) geri.addEventListener('click', function () { kaydir(-1); });
    if (ileri) ileri.addEventListener('click', function () { kaydir(1); });
    hepsi(el, '[data-es-iz]').forEach(function (t) { t.addEventListener('scroll', guncelle, { passive: true }); });
    window.addEventListener('resize', guncelle);
    el.__esGuncelle = guncelle;
    guncelle();
  }

  function sekmeler(el) {
    if (el.__esSekme) return; el.__esSekme = true;
    var dugmeler = hepsi(el, '[data-es-sekme]');
    var paneller = hepsi(el, '[data-es-panel]');
    function sec(n, odak) {
      dugmeler.forEach(function (d, k) {
        var acik = k === n;
        d.classList.toggle('is-on', acik);
        d.setAttribute('aria-selected', acik ? 'true' : 'false');
        d.tabIndex = acik ? 0 : -1;
        if (acik && odak) d.focus();
      });
      paneller.forEach(function (p, k) { p.hidden = k !== n; if (k === n) { var t = p.querySelector('[data-es-iz]'); if (t) t.scrollLeft = 0; } });
      if (el.__esGuncelle) el.__esGuncelle();
    }
    dugmeler.forEach(function (d, k) {
      d.tabIndex = k === 0 ? 0 : -1;
      d.addEventListener('click', function () { sec(k); });
      d.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); sec((k + 1) % dugmeler.length, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); sec((k - 1 + dugmeler.length) % dugmeler.length, true); }
      });
    });
  }

  function galeri(el) {
    if (el.__esGaleri) return; el.__esGaleri = true;
    var ana = el.querySelector('.es-oc__img');
    var kucukler = hepsi(el, '[data-es-kucuk]');
    if (!ana) return;
    kucukler.forEach(function (k) {
      k.addEventListener('click', function () {
        ana.removeAttribute('srcset');
        ana.src = k.getAttribute('data-es-kucuk');
        ana.alt = k.getAttribute('data-es-alt') || ana.alt;
        kucukler.forEach(function (b) { b.classList.toggle('is-on', b === k); b.setAttribute('aria-pressed', b === k ? 'true' : 'false'); });
      });
    });
  }

  function karsilastir(el) {
    if (el.__esKar) return; el.__esKar = true;
    var surgu = el.querySelector('.es-kar__surgu');
    if (!surgu) return;
    var yaz = function () { el.style.setProperty('--es-pos', surgu.value + '%'); };
    surgu.addEventListener('input', yaz);
    yaz();
  }

  function kur(kok) {
    kendisiVeAlti(kok, '[data-es-slider]').forEach(slider);
    kendisiVeAlti(kok, '[data-es-serit]').forEach(serit);
    kendisiVeAlti(kok, '[data-es-sekmeler]').forEach(sekmeler);
    kendisiVeAlti(kok, '[data-es-galeri]').forEach(galeri);
    kendisiVeAlti(kok, '[data-es-kar]').forEach(karsilastir);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { kur(document); });
  else kur(document);
  document.addEventListener('shopify:section:load', function (e) { kur(e.target); });
  // Tema editörü: seçilen slayt görünür kalsın (otomatik geçiş durur), seçilen sekme açılsın.
  document.addEventListener('shopify:block:select', function (e) {
    if (!e.target.closest) return;
    var sekme = e.target.closest('[data-es-sekme]');
    if (sekme) { sekme.click(); return; }
    var slayt = e.target.closest('[data-es-slayt]');
    var el = slayt && slayt.closest('[data-es-slider]');
    if (!el || !el.__esGit) return;
    el.__esDurdur(true);
    el.__esGit(hepsi(el, '[data-es-slayt]').indexOf(slayt));
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var el = e.target.closest && e.target.closest('[data-es-slider]');
    if (el && el.__esDurdur) el.__esDurdur(false);
  });
})();
